
import List from './list/index.vue';
import Details from './details/index.vue';
export default [
  {
    path: 'list',
    name: '',
    component: List,
    meta: {
      title: '订单列表',
      breadCrumbShowIndexArr: [0, 2]
    }
  },
  {
    path: 'details',
    name: '',
    component: Details,
    meta: {
      title: '订单详情',
      breadCrumbShowIndexArr: [0, 2, 3]
    }
  }
];
